import { useEffect, useState } from "react";

/**
 * Relógio para durações "ao vivo" (ex.: sessão em andamento). Ler `Date.now()`
 * direto no render deixa o componente impuro: o valor muda a cada render sem
 * que nada tenha mudado. Com `intervalMs = null` o relógio fica parado.
 */
export function useNow(intervalMs: number | null = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (intervalMs === null) return;
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
